import html from "./ProvideFeedback.html"
import "./ProvideFeedback.css"

var module = angular.module("ResearchKitApplicationModule");
module.component('provideFeedback', {
	template: html,
	bindings: {
		"model": "<"
	},
	controller: 'provideFeedbackController',
	controllerAs: 'vm'
});

module.controller("provideFeedbackController", ["$http", "$window", "ceUrl",
	function ($http, $window, ceUrl) {
		var vm = this;

		vm.$onInit = function () {
			vm.feedbackSubject = vm.model.subjectOptions[0].value;
		};

		vm.submitFeedback = function () {

			if (!vm.feedbackComment) return;

			vm.sending = true;

			$http.post(ceUrl.make('api/userfeedback/PersistUserSiteFeedback'), {
				feedbackComment: vm.feedbackSubject + ": " + vm.feedbackComment,
				source: vm.model.source,
				sourceType: "ApplicationName"
			}).then(function () {
				vm.success = true;
				vm.feedbackComment = "";
				vm.feedbackSubject = "Feedback";
				setTimeout(function () {
					//url must be double encoded because angular automatically decodes slashes
					$window.location = decodeURIComponent(decodeURIComponent(vm.model.previousLocation));
				}, 1000);
			}, function () {
				vm.error = true;
			}).finally(function () {
				vm.sending = false;
			});
		};
	}
]);
